import { takeLatest, put, call } from 'redux-saga/effects';
import * as CorporateBulkCaseRequestAction from './action'
import { HTTP_HEADERS, HTTP_HEADERS_FORMDATA, HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, HTTP_RESPONSE_TYPE_ARRAYBUFFER } from '../../constants';
import request from '../../components/Utils/httpHelper';
import { CORE_API} from '../../config'


export function* fetchBulkReportRequests(action) {
    let requestUrl = `${CORE_API}/bulkreport/request/records/${action.data.caseType}/${action.data.pageNumber}/${action.data.pageSize}/sort/${action.data.sortField}/${action.data.sortDirection}`;
    try {
        const searchResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(CorporateBulkCaseRequestAction.fetchBulkReportRequestsSuccess(searchResult.data));
    } catch (err) {
        yield put(CorporateBulkCaseRequestAction.fetchBulkReportRequestsFailure(err))
    }
}
export function* getBulkReportRequests() {
    yield takeLatest(CorporateBulkCaseRequestAction.FETCH_BULK_REPORT_REQUESTS, fetchBulkReportRequests);
}


export function* downloadBulkReportRequestTemplateSaga(action) {
    let requestUrl = `${CORE_API}/bulkreport/request/${action.data.caseType}/template`;
    try {
        const searchResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS_RESPONSE_TYPE_ARRAYBUFFER, responseType: HTTP_RESPONSE_TYPE_ARRAYBUFFER  });
        yield put(CorporateBulkCaseRequestAction.downloadBulkReportRequestTemplateSuccess(searchResult.data));
    } catch (err) {
        yield put(CorporateBulkCaseRequestAction.downloadBulkReportRequestTemplateFailure(err))
    }
}
export function* getBulkReportRequestTemplate() {
    yield takeLatest(CorporateBulkCaseRequestAction.DOWNLOAD_BULK_REPORT_REQUEST_TEMPLATE, downloadBulkReportRequestTemplateSaga);
}

export function* submitBulkReportRequestSaga(action) {
    const formData = new FormData();
    formData.append('file', action.data.file);
    let requestUrl = `${CORE_API}/bulkreport/request/${action.data.caseType}/submit`;
    try {
        const searchResult = yield call(request, requestUrl, { data: formData, method: 'POST', headers: HTTP_HEADERS_FORMDATA });
        yield put(CorporateBulkCaseRequestAction.submitBulkReportRequestSuccess(searchResult.data));
    } catch (err) {
        yield put(CorporateBulkCaseRequestAction.submitBulkReportRequestFailure(err))
    }
}
export function* submitBulkReportRequest() {
    yield takeLatest(CorporateBulkCaseRequestAction.SUBMIT_BULK_REPORT_REQUEST, submitBulkReportRequestSaga);
}

export function* downloadRecordRequestFileSaga(action) {
    let requestUrl = `${CORE_API}/bulkreport/request/record/excel/${action.data}`;
    try {
        const searchResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(CorporateBulkCaseRequestAction.downloadRecordRequestFileSuccess(searchResult.data));
    } catch (err) {
        yield put(CorporateBulkCaseRequestAction.downloadRecordRequestFileFailure(err))
    }
}
export function* getRecordRequestFile() {
    yield takeLatest(CorporateBulkCaseRequestAction.DOWNLOAD_RECORD_REQUEST_FILE, downloadRecordRequestFileSaga);
}